require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-truth-about-yoga-and-muscle.json") })
        }
      }, "path---blog-the-truth-about-yoga-and-muscle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-truth-about-yoga-and-muscle!./.cache/json/blog-the-truth-about-yoga-and-muscle.json
// module id = 310
// module chunks = 231608221292675